// removed by extract-text-webpack-plugin
module.exports = {"vis-toggle":"styles-module__vis-toggle___2JuYy"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/RightPanel/VisToggle/styles.module.css
// module id = 1080
// module chunks = 0